export default __webpack_public_path__ + "c0c33ccaa25cf9ac9462aa5c864494a3.png";